import { useEffect } from "react";

const SITE_URL = "https://charith.it.com";
const DEFAULT_IMAGE = `${SITE_URL}/brand/logo-mark-512.png`;

function setMeta(selectorAttr, selectorValue, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${selectorAttr}="${selectorValue}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(selectorAttr, selectorValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(data) {
  const id = "page-jsonld";
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

// Per-route <title>/meta/canonical/JSON-LD. CRA has no server-side
// rendering, so this only updates what's in the DOM after JS runs — that's
// enough for Google (Googlebot executes JS before indexing), but crawlers
// that DON'T run JS (many link-preview bots) will still see the static
// defaults baked into public/index.html instead of these per-page values.
export default function Seo({ title, description, path = "/", image, jsonLd }) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const img = image || DEFAULT_IMAGE;

    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    setCanonical(url);
    setJsonLd(jsonLd);

    return () => setJsonLd(null);
  }, [title, description, path, image, jsonLd]);

  return null;
}
